import React from 'react';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';

const blogData = [
  {
    title:
      'The Importance of Mental Health: Understanding and Managing Anxiety Disorders',
    thumbUrl: 'images/blog/post_1.jpeg',
    date: 'March 12',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
    thumbUrl: 'images/blog/post_2.jpeg',
    date: 'March 11',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle',
    thumbUrl: 'images/blog/post_3.jpeg',
    date: 'March 9',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'Managing Chronic Pain: Treatment Options and Strategies',
    thumbUrl: 'images/blog/post_4.jpeg',
    date: 'March 8',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'Understanding and Managing Diabetes: Tips for Healthy Living',
    thumbUrl: 'images/blog/post_5.jpeg',
    date: 'March 5',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'The Role of Physical Therapy in Injury Recovery and Prevention',
    thumbUrl: 'images/blog/post_6.jpeg',
    date: 'March 2',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'Breaking the Stigma: Raising Awareness for Mental Health Issues',
    thumbUrl: 'images/blog/post_7.jpeg',
    date: 'Feb 28',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'Allergies and Asthma: Causes, Symptoms, and Treatment Options',
    thumbUrl: 'images/blog/post_8.jpeg',
    date: 'Feb 26',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'Caring for Your Skin: Tips for Healthy, Glowing Skin',
    thumbUrl: 'images/blog/post_9.jpeg',
    date: 'Feb 25',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
];

export default function Blog() {
  pageTitle('Blog');
  
  const pageStyles = {
    background: 'linear-gradient(180deg, #f0f7ff 0%, #d4e8ff 20%, #a8d1ff 40%, #5ba3e0 60%, #2563a8 80%, #0f3460 100%)',
    minHeight: '100vh',
  };

  return (
    <div style={pageStyles}>
      <style>{`
        /* Global styling for blog page */
        .blog-page {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
        
        /* Light section styling - top area */
        .blog-page .breadcrumb-section {
          background: linear-gradient(135deg, 
            rgba(240, 247, 255, 0.95) 0%, 
            rgba(212, 232, 255, 0.95) 50%,
            rgba(168, 209, 255, 0.9) 100%
          );
          padding: 50px 30px;
          border-radius: 16px;
          margin: 20px;
          box-shadow: 0 8px 32px rgba(37, 99, 168, 0.15);
          backdrop-filter: blur(10px);
        }
        
        .blog-page .breadcrumb-section h1,
        .blog-page .breadcrumb-section h2,
        .blog-page .breadcrumb-section h3 {
          color: #0f3460 !important;
          font-weight: 700 !important;
          text-shadow: 0 2px 4px rgba(255, 255, 255, 0.8);
          letter-spacing: 0.5px;
        }
        
        .blog-page .breadcrumb-section span,
        .blog-page .breadcrumb-section p,
        .blog-page .breadcrumb-section div {
          color: #0f3460 !important;
          font-weight: 500;
        }
        
        .blog-page .breadcrumb-section a {
          color: #2563a8 !important;
          font-weight: 600;
        }
        
        /* Blog grid section - lighter middle area */
        .blog-page .blog-grid-section {
          background: linear-gradient(135deg,
            rgba(212, 232, 255, 0.85) 0%,
            rgba(168, 209, 255, 0.85) 50%,
            rgba(91, 163, 224, 0.85) 100%
          );
          padding: 70px 30px;
          border-radius: 16px;
          margin: 20px;
          box-shadow: 0 8px 32px rgba(37, 99, 168, 0.2);
          backdrop-filter: blur(10px);
        }
        
        .blog-page .blog-grid-section h1,
        .blog-page .blog-grid-section h2,
        .blog-page .blog-grid-section h3 {
          color: #0f3460 !important;
          font-weight: 700 !important;
          text-shadow: 0 2px 8px rgba(255, 255, 255, 0.9);
          letter-spacing: 0.5px;
        }
        
        .blog-page .blog-grid-section p,
        .blog-page .blog-grid-section span,
        .blog-page .blog-grid-section div {
          color: #0f3460 !important;
          font-weight: 500;
        }
        
        /* Blog cards - very light with dark text */
        .blog-page .blog-card,
        .blog-page [class*="blog"] [class*="card"],
        .blog-page [class*="post"] {
          background: linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(240, 247, 255, 0.98) 100%
          ) !important;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 8px 24px rgba(15, 52, 96, 0.25);
          transition: all 0.3s ease;
          border: 2px solid rgba(168, 209, 255, 0.5);
        }
        
        .blog-page .blog-card:hover,
        .blog-page [class*="blog"] [class*="card"]:hover,
        .blog-page [class*="post"]:hover {
          transform: translateY(-8px);
          box-shadow: 0 16px 48px rgba(15, 52, 96, 0.35);
          border-color: rgba(91, 163, 224, 0.8);
        }
        
        .blog-page .blog-card h3,
        .blog-page .blog-card h4,
        .blog-page .blog-card p,
        .blog-page .blog-card span,
        .blog-page .blog-card div,
        .blog-page [class*="blog"] [class*="card"] h3,
        .blog-page [class*="blog"] [class*="card"] h4,
        .blog-page [class*="blog"] [class*="card"] p,
        .blog-page [class*="blog"] [class*="card"] span,
        .blog-page [class*="post"] h3,
        .blog-page [class*="post"] h4,
        .blog-page [class*="post"] p,
        .blog-page [class*="post"] span {
          color: #0f3460 !important;
          font-weight: 600;
        }
        
        .blog-page .blog-card .date,
        .blog-page [class*="date"] {
          color: #2563a8 !important;
          font-weight: 700;
          font-size: 0.95em;
        }
        
        /* Banner section - darker with white text */
        .blog-page .banner-section {
          background: linear-gradient(135deg,
            rgba(37, 99, 168, 0.95) 0%,
            rgba(15, 52, 96, 0.95) 100%
          );
          padding: 70px 30px;
          border-radius: 16px;
          margin: 20px;
          box-shadow: 0 8px 32px rgba(15, 52, 96, 0.4);
          backdrop-filter: blur(10px);
        }
        
        .blog-page .banner-section h1,
        .blog-page .banner-section h2,
        .blog-page .banner-section h3,
        .blog-page .banner-section p,
        .blog-page .banner-section span,
        .blog-page .banner-section div {
          color: #ffffff !important;
          text-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);
          font-weight: 600;
        }
        
        .blog-page .banner-section h1,
        .blog-page .banner-section h2 {
          font-weight: 800 !important;
        }
        
        /* Buttons - high contrast */
        .blog-page button,
        .blog-page .btn,
        .blog-page a.btn,
        .blog-page [class*="button"] {
          background: linear-gradient(135deg, #2563a8 0%, #0f3460 100%) !important;
          color: #ffffff !important;
          border: 2px solid #ffffff !important;
          padding: 14px 32px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 1.05em;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-block;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          box-shadow: 0 4px 12px rgba(15, 52, 96, 0.3);
        }
        
        .blog-page button:hover,
        .blog-page .btn:hover,
        .blog-page a.btn:hover,
        .blog-page [class*="button"]:hover {
          background: linear-gradient(135deg, #0f3460 0%, #082340 100%) !important;
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(15, 52, 96, 0.5);
          border-color: #a8d1ff !important;
        }
        
        /* Links in light sections */
        .blog-page .breadcrumb-section a,
        .blog-page .blog-grid-section a:not(.btn),
        .blog-page .blog-card a:not(.btn) {
          color: #2563a8 !important;
          font-weight: 600;
          transition: color 0.3s ease;
        }
        
        .blog-page .breadcrumb-section a:hover,
        .blog-page .blog-grid-section a:not(.btn):hover,
        .blog-page .blog-card a:not(.btn):hover {
          color: #0f3460 !important;
          text-decoration: underline;
        }
        
        /* Links in dark sections */
        .blog-page .banner-section a:not(.btn) {
          color: #a8d1ff !important;
          font-weight: 600;
        }
        
        .blog-page .banner-section a:not(.btn):hover {
          color: #ffffff !important;
        }
        
        /* Social share icons */
        .blog-page .social-share,
        .blog-page [class*="social"] {
          background: rgba(255, 255, 255, 0.95);
          padding: 10px 16px;
          border-radius: 10px;
          display: inline-flex;
          gap: 12px;
          box-shadow: 0 4px 12px rgba(15, 52, 96, 0.2);
        }
        
        .blog-page .social-share svg,
        .blog-page .social-share i,
        .blog-page [class*="social"] svg,
        .blog-page [class*="social"] i {
          color: #2563a8 !important;
          transition: all 0.3s ease;
        }
        
        .blog-page .social-share svg:hover,
        .blog-page .social-share i:hover,
        .blog-page [class*="social"] svg:hover,
        .blog-page [class*="social"] i:hover {
          color: #0f3460 !important;
          transform: scale(1.15);
        }
        
        /* Enhanced text visibility */
        .blog-page * {
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
        }
      `}</style>
      
      <div className="blog-page">
        <Section topMd={170} bottomMd={96} bottomLg={70}>
          <div className="breadcrumb-section">
            <Breadcrumb title="Psychology and Life Style" />
          </div>
        </Section>
        
        <Section bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="blog-grid-section">
            <BlogSectionStyle2 data={blogData} />
          </div>
        </Section>
        
        <Section className="cs_footer_margin_0">
          <div className="banner-section">
            <BannerSectionStyle9
              title="Don't Let Your Health <br />Take a Backseat!"
              subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
              imgUrl="/images/doctors/banner_img_3.png"
            />
          </div>
        </Section>
      </div>
    </div>
  );
}